export enum MemberRole {
  CUSTOMER = 'Customer',
  ADMIN = 'Admin',
  VENDOR = 'Vendor',
  RESTAURANT_OWNER = 'Restaurant Owner',
}
